import { useTranslate } from 'hooks/useTranslate';
import { FC } from 'react';

import { useCognitoSaml } from 'modules/auth/hooks/useCognitoSaml';

const MyriamIDPForm: FC = () => {
  const { t } = useTranslate();
  const { loginWithMYRIAM } = useCognitoSaml();

  return (
    <div className="auth-form mt-4">
      <div className="form-group">
        <button
          type="button"
          className="btn btn-lg btn-secondary btn-block btn-login-myriam-idp"
          onClick={loginWithMYRIAM}
        >
          <em className="icon ni ni-send ni-lock" />
          <span>{t('LoginWithMyriamIdp')}</span>
        </button>
      </div>
    </div>
  );
};

export default MyriamIDPForm;
